import * as React from 'react';
/*import {
    useRedirect,
} from 'react-admin';*/

import EditComponentAdmin from "../../_common/EditComponentAdmin";
import CountriesEditCreate from "./CountriesEditCreate";
import {useRedirect} from "react-admin";

export const CountriesEdit = props => {
    const {location} = props;
    const {search} = location;
    let idSource = '';
    if(search){
        let url = new URL('https://test/' + search);
        idSource = url.searchParams.get('customerId')
    }
    const redirect = useRedirect()

    return (
        <EditComponentAdmin
            {...props}
            //transform={(event) => transform(resource, event)}
            title={''}
            //editDialog={idSource}
            onSuccess={() => idSource ? props.history.goBack() : redirect('list', props.basePath)}
            /*onSuccess={() => idSource
                ? redirect(`/locating/${idSource}/2`)
                : redirect('list', props.basePath)
            }*/
            //fullWidth
            //   undoable={false} //Подтверждение удаления
            //   actions={<PostEditActions/>}
        >
            <CountriesEditCreate idSource={idSource}/>
        </EditComponentAdmin>
    )
};